import React from "react";
import styles from './loader.module.scss';
import KoIcon from '@kwapio/icons';

function KoLoader({size, circle=true, noBg}) {
  return (
    <div className={`${size ? styles.small : styles.large} ${noBg ? styles.noBgremov :''}` }>
      {/* {circle && <div className={styles.loader}></div>} */}
      {circle &&
      <div className={noBg ? styles.noBg : styles.bg} >
        <KoIcon name='LoaderFilled' width={size? 20 : 40} height={size? 20 : 40}/>
      </div>
      }
    </div>
  );
}

export default KoLoader;